"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("@osmosys/models");
const react_1 = require("react");
const react_2 = require("@osmosys/react");
const react_hanger_1 = require("react-hanger");
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../../../graphql");
const react_use_1 = require("react-use");
exports.useFeatureSettingsMutation = (userId, featureFlagOverrides, stickyMs = 3000) => {
    const { setState: setFeatureFlags, state: featureFlags } = react_hanger_1.useSetState(featureFlagOverrides);
    const [saveFeatureFlags, featureFlagsSaveResult] = react_hooks_1.useMutation(graphql_1.updateUserFeatureFlags, {
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: graphql_1.loadApp,
            },
        ],
    });
    react_use_1.useUpdateEffect(() => {
        saveFeatureFlags({
            variables: {
                data: models_1.dropNullFeatureFlags(featureFlags),
                id: userId,
            },
        });
    }, [featureFlags, featureFlagOverrides]);
    react_1.useEffect(() => {
        setFeatureFlags(featureFlagOverrides);
    }, [featureFlagOverrides]);
    const [stickiedSuccess, trigger] = react_2.useTimedToggle(stickyMs);
    const succeeded = !featureFlagsSaveResult.loading && featureFlagsSaveResult.data;
    react_1.useEffect(() => {
        if (succeeded) {
            trigger();
        }
    }, [succeeded]);
    return {
        featureFlags,
        featureFlagsSaveResult,
        setFeatureFlags,
        stickiedSuccess,
    };
};
//# sourceMappingURL=useFeatureSettingsMutation.js.map